import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import PaginationModule from '@grupa-pracuj/react-pagination';
import PreviousButton from 'src/components/Pagination/PreviousButton';
import NextButton from 'src/components/Pagination/NextButton';
import ScrollContainer from 'src/components/Pagination/ScrollContainer';
import 'src/components/Pagination/PaginationWrapper.scss';


class PaginationWrapper extends PureComponent {
  render() {
    const { children, activeTab } = this.props;
    const dataTest = `pagination-${activeTab}`;

    return (
      <PaginationModule.Pagination>
        <div data-test={ dataTest } styleName="pagination">
          <PreviousButton />

          <ScrollContainer>{children}</ScrollContainer>

          <NextButton />
        </div>
      </PaginationModule.Pagination>
    );
  }
}

PaginationWrapper.propTypes = {
  activeTab: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default PaginationWrapper;
